export let DropCameraType = /*#__PURE__*/function (DropCameraType) {
  DropCameraType[DropCameraType["PHOTO"] = 0] = "PHOTO";
  DropCameraType[DropCameraType["RECORD"] = 1] = "RECORD";
  return DropCameraType;
}({});
export const defaultPhotoMimeType = 'image/webp';
export const defaultPhotoExt = 'webp';
export const defaultRecordMimeType = 'video/webm';
export const defaultRecordExt = 'webm';
export const defaultName = type => type === DropCameraType.PHOTO ? `photo-${new Date().getTime().toString()}` : `record-${new Date().getTime().toString()}`;